/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';

import { CtaButton } from '../../../../../styles/ui/Button';
import OnboardingStatusBadge from '../../components/OnboardingStatusBadge';
import {
   BACKGROUND_CHECK_STATUS_LABEL,
   ADMISSION_EXAM_STATUS_LABEL,
} from '../../constants';
import { formatDateBr } from '../../utils/format';
import { Card, CardHead, ObItem } from '../styles';

// ---------------------------------------------------------------------------
// Card-resumo do onboarding na ficha (redesign Claude Design 2026-07-14):
// lista VERTICAL de fatos (mock .ob-item), lado a lado com a esteira no Split.
// Componente apresentacional — o fetch (gate por perm + stage) vive no
// CandidateShow, que só o renderiza quando o onboarding existe.
// ---------------------------------------------------------------------------

export default function OnboardingCard({ candidateId, onboarding }) {
   const navigate = useNavigate();

   if (!onboarding) return null;

   // PENDENTE exibe como vazio ("—") — o card só destaca resultado registrado.
   const resultLabel = (status) =>
      status && status !== 'PENDENTE'
         ? BACKGROUND_CHECK_STATUS_LABEL[status]
         : null;

   const examLabel =
      onboarding.admission_exam_status &&
      onboarding.admission_exam_status !== 'PENDENTE'
         ? ADMISSION_EXAM_STATUS_LABEL[onboarding.admission_exam_status]
         : null;
   const startDate = onboarding.start_date
      ? formatDateBr(onboarding.start_date)
      : null;

   const rows = [
      {
         key: 'Etapa',
         value: <OnboardingStatusBadge value={onboarding.status} />,
         isPill: true,
      },
      // As 2 sub-análises do Background Check (0067) — "Avaliação jurídica" é
      // o rename do Caio pra triagem de litígios.
      {
         key: 'Avaliação jurídica',
         value: resultLabel(onboarding.litigation_screening_status),
      },
      {
         key: 'Histórico profissional',
         value: resultLabel(onboarding.professional_history_status),
      },
      { key: 'Exame admissional', value: examLabel },
      { key: 'Data de início', value: startDate },
   ];

   return (
      <Card>
         <CardHead>
            <h2>Onboarding de admissão</h2>
            <CtaButton
               type="button"
               onClick={() =>
                  navigate(`/hr/recruitment/candidates/${candidateId}/onboarding`)
               }
            >
               <FaExternalLinkAlt size={13} /> Abrir onboarding
            </CtaButton>
         </CardHead>

         {rows.map((row) => (
            <ObItem key={row.key}>
               <div className="ob-label">{row.key}</div>
               {row.isPill ? (
                  row.value
               ) : (
                  <div className={`ob-value${row.value ? '' : ' empty'}`}>
                     {row.value ?? '—'}
                  </div>
               )}
            </ObItem>
         ))}
      </Card>
   );
}

OnboardingCard.propTypes = {
   candidateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onboarding: PropTypes.shape({
      status: PropTypes.string,
      litigation_screening_status: PropTypes.string,
      professional_history_status: PropTypes.string,
      admission_exam_status: PropTypes.string,
      start_date: PropTypes.string,
   }),
};
